export const Namespace = 'TASKS';
export enum TaskAction {
	CreatedTask = 'CREATED_TASK',
	CompletedTask = 'COMPLETED_TASK',
	CancelledTask = 'CANCELLED_TASK',
	TaskNotificationReceived = 'TASK_NOTIFICATION_RECEIVED',
	ApproveWithComment = 'APPROVE_WITH_COMMENT',
	QuickApprove1 = 'QUICK_APPROVE_1',
	QuickApprove2 = 'QUICK_APPROVE_2',
	DenyWithComment = 'DENY_WITH_COMMENT',
	QuickDeny1 = 'QUICK_DENY_1',
	QuickDeny2 = 'QUICK_DENY_2',
	Cancel = 'CANCEL'
};



// WEBPACK FOOTER //
// ./src/sharebase/domain/task.actions.ts